import React from "react";
import { Grid } from "@mui/material";
import { Skeleton } from '@mui/material';

import useStyles from "./styles";

const SkeletonCustomer = () => {
  const heightInput = 60;

  const classes = useStyles();

  return (
    <Grid container item xs={12} direction="row">
      <Grid
        container
        item
        xs={12}
        spacing={2}
        direction="row"
        className={classes.formContent}
      >
        <Grid item xs={12}>
          <Skeleton variant="text" width="30%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" width="30%" height={heightInput} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" width="30%" height={heightInput} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" width="30%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="text" width="30%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Skeleton variant="text" width="100%" height={heightInput} />
        </Grid>
        <Grid
          item
          container
          xs={12}
          direction="row"
          justifyContent="space-between"
        >
          <Grid item xs={3}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Grid>
          <Grid item xs={3}>
            <Skeleton variant="text" width="100%" height={heightInput} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SkeletonCustomer;
